import React, { useState } from 'react'
import { Minus, Plus } from '../../atoms/NewIcons'

const QuantityHandler = ({ value, onValueChange, inputDisabled }) => {
  // Se è settato onValueChange, il value è gestito esternamente
  // altrimenti si usa lo state (es. storybook)
  const [stateVal, setStateVal] = useState(value)
  const getVal = () => {
    return onValueChange ? value : stateVal
  }
  const changeVal = (newVal, action) => {
    onValueChange ? onValueChange(newVal, action) : setStateVal(newVal)
  }

  return (
    <div className="quantity-handler">
      <button
        className="quantity-handler__button quantity-handler__button--minus"
        onClick={() => changeVal(getVal() - 1, 'remove')}
      >
        <Minus />
      </button>
      <input
        className="quantity-handler__input"
        value={getVal() || ''}
        onChange={(e) => changeVal(parseInt(e.target.value), 'set' || 0)}
        disabled={inputDisabled}
        placeholder="0"
      ></input>
      <button
        className="quantity-handler__button quantity-handler__button--plus"
        onClick={() => changeVal(getVal() + 1, 'add')}
      >
        <Plus />
      </button>
    </div>
  )
}

export default React.memo(QuantityHandler)
